import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '='
    },
    template: `
        <div class="well color01">
            <h2>{{ 'reports.Courses in progress' | translate }}</h2>
            <pagination-tools custom-options="[5,10]" list="vm.list"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="tablewrapper">
                <table ng-if="!vm.list.loading && vm.list.items.length" class="data01" datatable="ng" dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th class="w1p checkbox sorting_disabled" rowspan="1" colspan="1"></th>
                        <th>{{ 'reports.Course' | translate }}</th>
                        <th>{{ 'reports.Version' | translate }}</th>
                        <th ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ 'reports.Participation' | translate }}</th>
                        <th>{{ 'reports.Status' | translate }}<br>
                            <small>({{ 'reports.Status creation date' | translate }})</small>
                        </th>
                        <th>{{ 'reports.Progress of mandatory trainings' | translate }}<br>
                            <small>({{ 'reports.Total progress' | translate }})</small>
                        </th>
                        <th>{{ 'reports.Next deadline' | translate }}</th>
                        <th class="none dt-hide"></th>
                    </tr>
                </thead>
                <tbody class="ui-selectable">
                    <tr ng-repeat="item in vm.list.items">
                        <td class="w1p checkbox" rowspan="1" colspan="1"></td>
                        <td>
                            <a
                                ng-if="vm.PrivilegeService.canManageCourses()"
                                ui-sref="authorized.courses.courses.edit.occurrence.edit.general({id: item.courseId, occurrenceId: item.occurrenceId})"
                            >
                                {{ item.course }}
                            </a>
                            <span ng-if="!vm.PrivilegeService.canManageCourses()">{{ item.course }}</span>
                        </td>
                        <td>{{ item.version }}</td>
                        <td ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ item.type }}</td>
                        <td>{{ vm.COURSE_STATUS_TYPE_ENUM.LABELS[item.status] }}<br>
                            <small>({{ vm.MomentService.formatDate(item.date) }})</small>
                        </td>
                        <td>{{ item.passedRequiredTrainingCount }}/{{ item.requiredTrainingCount }}<br>
                            <small>({{ item.passedTrainingCount }}/{{ item.trainingCount }})</small>
                        </td>
                        <td>{{ vm.MomentService.formatDate(item.nextDeadline) }}</td>
                        <td>
                            <h3>{{ 'reports.Trainings' | translate }}</h3>
                            <div class="form">
                                <div class="row">
                                    <span class="label">{{ 'reports.Order of trainings' | translate }}</span>
                                    <div class="items">
                                        <span class="text">{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS[item.trainingOrderType] }}</span>
                                    </div>
                                </div>
                            </div>
                            <list-empty list="item.trainings" show-add-message="false"></list-empty>
                            <table class="data01 mt1em" ng-if="item.trainings.length">
                                <thead>
                                    <tr>
                                        <th>{{ 'reports.Training name' | translate }}</th>
                                        <th>{{ 'reports.Type' | translate }}</th>
                                        <th>{{ 'reports.Status' | translate }}</th>
                                        <th>{{ 'reports.Date' | translate }}</th>
                                        <th>{{ 'reports.Result' | translate }} <small>(%)</small></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr ng-repeat="training in item.trainings">
                                        <td>{{ training.name }}</td>
                                        <td>{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS[training.type] }}</td>
                                        <td>{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[training.status] }}</td>
                                        <td>{{ vm.MomentService.formatDate(training.date) }}</td>
                                        <td>
                                            <span ng-if="training.type==vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST
                                            && training.result">{{ training.result }}%</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
                <pagination list="vm.list"></pagination>
            </div>
        </div>
    `
})
export default class {
    constructor (CourseResource, TokenService, MomentService, PrivilegeService, SiteService, ListFactory,
                 DATATABLES, COURSE_STATUS_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_TRAINING_STATUS_TYPE_ENUM, COURSE_TRAINING_ORDER_TYPE_ENUM,
                 ROLE_PRIVILEGE_ENUM) {
        this.CourseResource = CourseResource;
        this.TokenService = TokenService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.DATATABLES = DATATABLES;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.list = ListFactory.createWithPagination(CourseResource.userCourseProgressReport.bind(CourseResource));
    }

    $onInit () {
        this.filter = {
            statuses: [
                this.COURSE_STATUS_TYPE_ENUM.KEYS.NOT_STARTED,
                this.COURSE_STATUS_TYPE_ENUM.KEYS.IN_PROGRESS
            ],
            pageSize: 5,
            userId: this.user.id
        };
        if (!this.PrivilegeService.isCompanyAdmin()) {
            this.filter.siteIds = this.SiteService.getSitesByPrivileges([
                this.ROLE_PRIVILEGE_ENUM.KEYS.REPORTS_EMPLOYEE_COURSE_PROGRESS_VIEW
            ]).map(site => site.id);
        }
        this.list.fetch({}, this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/coursesInProgress/index.js